import { render, staticRenderFns } from "./AlertGroupManagement.vue?vue&type=template&id=edbab492&scoped=true&"
import script from "./AlertGroupManagement.vue?vue&type=script&lang=js&"
export * from "./AlertGroupManagement.vue?vue&type=script&lang=js&"
import style0 from "./AlertGroupManagement.vue?vue&type=style&index=0&id=edbab492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbab492",
  null
  
)

export default component.exports